// Same pattern as assets/password-modal.js (PasswordModal extends
// DetailsModal, both defined in assets/global.js): the native
// {% form 'customer' %} this modal wraps does a real, non-AJAX
// full-page submit/reload, so after that reload the modal needs to
// reopen itself to actually show the success/error state Liquid just
// rendered inside it — otherwise the page would just reload back to
// the closed modal with no visible feedback at all.
//
// Guarded like every other custom element in this theme (see e.g.
// cart-disclosure-modal.js) — needed here specifically because this
// file is loaded via two separate <script> tags on any page that
// renders both a waitlist CTA that opens a modal via this element AND
// a second one (image-banner.liquid's hero button and final-cta.liquid
// both render their own <script src="waitlist-modal.js">, and the
// browser executes each <script> tag's top-level `class` declaration
// in the same shared global scope — the second execution threw
// "Identifier 'WaitlistModal' has already been declared" on every
// homepage load, confirmed live, reproducing even before anything in
// this session touched the file). Wrapping in the same class-registry
// check the rest of the theme already uses fixes it without needing to
// touch either section's markup or de-duplicate the script tag itself.
if (!customElements.get('waitlist-modal')) {
  class WaitlistModal extends ModalDialog {
    constructor() {
      super();
      if (this.querySelector('input[aria-invalid="true"]') || this.querySelector('[data-waitlist-submitted]')) {
        this.show();
      }

      // Real full-page form POST/reload, not AJAX — deliberately no
      // preventDefault() here, the browser needs to actually navigate.
      // This is purely a visual/re-entrancy guard: Shopify's native
      // customer form has an invisible hCaptcha check that can add a
      // few seconds of delay before the page actually navigates away,
      // and with no feedback during that gap a real user clicked the
      // button multiple times (reported live). Disabling on submit
      // doesn't cancel the in-flight submission — the browser already
      // captured the form data synchronously when the submit event
      // fired — it only stops a second click from firing a duplicate.
      const form = this.querySelector('form');
      const submitButton = form ? form.querySelector('button[type="submit"]') : null;
      if (form && submitButton) {
        form.addEventListener('submit', () => {
          if (submitButton.classList.contains('loading')) return;
          submitButton.classList.add('loading');
          submitButton.setAttribute('aria-disabled', 'true');
          submitButton.disabled = true;
          const spinner = submitButton.querySelector('.loading__spinner');
          if (spinner) spinner.classList.remove('hidden');
        });
      }
    }
  }

  customElements.define('waitlist-modal', WaitlistModal);
}
